var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1911_7033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19H16C16.55 19 17 18.55 17 18V5C17 4.45 16.55 4 16 4H8C7.45 4 7 4.45 7 5V18C7 18.55 7.45 19 8 19ZM3 17H5C5.55 17 6 16.55 6 16V7C6 6.45 5.55 6 5 6H3C2.45 6 2 6.45 2 7V16C2 16.55 2.45 17 3 17ZM18 7V16C18 16.55 18.45 17 19 17H21C21.55 17 22 16.55 22 16V7C22 6.45 21.55 6 21 6H19C18.45 6 18 6.45 18 7Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1911_7033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselCard);
export default __webpack_public_path__ + "static/media/carousel_card.0fcd989e3cf44b7d0c7c6333d6eb9227.svg";
export { ForwardRef as ReactComponent };